var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0219 6.96599C10.0944 6.96596 10.1662 6.98027 10.2331 7.00807C10.3 7.03587 10.3608 7.07662 10.4119 7.12799L15.3679 12.06C15.4712 12.1635 15.5293 12.3037 15.5293 12.45C15.5293 12.5962 15.4712 12.7365 15.3679 12.84C15.2644 12.9433 15.1241 13.0013 14.9779 13.0013C14.8317 13.0013 14.6914 12.9433 14.588 12.84L10.0219 8.29799L5.39191 12.84C5.28841 12.9433 5.14819 13.0013 5.00195 13.0013C4.85571 13.0013 4.71543 12.9433 4.61194 12.84C4.50862 12.7365 4.45056 12.5962 4.45056 12.45C4.45056 12.3037 4.50862 12.1635 4.61194 12.06L9.6319 7.12799C9.68306 7.07667 9.74387 7.03595 9.81079 7.00815C9.87771 6.98035 9.94945 6.96602 10.0219 6.96599Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.3aea1077980f7c2d8415ba3f9f88846d.svg";
export { ForwardRef as ReactComponent };